/* MenuItem.title from Backend includes HTML which is targeted by this CSS */
strong.bio-component {
  font-weight: 700;
  font-family: PoppinsBold;
}

/* For Buttons */
div[tabindex]:focus-visible {
  outline-width: 4px;
  outline-color: #050a00;
  outline-offset: 1px;
}

a[role="link"][tabindex]:focus-visible {
  outline-width: 2px;
  outline-color: #050a00;
  outline-offset: 1px;
}
